import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

function SubHeading({ id, Icon, children }) {
  return (
    <StyledSubHeading>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className=" font-weight-bold text-primary m-0">
          {Icon && <Icon className="me-2" />}
          <FormattedMessage id={id} />
          {children}
        </h3>
      </div>
    </StyledSubHeading>
  );
}

export default SubHeading;

const StyledSubHeading = styled.div`
  font-weight: 500;
  font-size: 24px;
  color: #2572bc;
  h3 {
    display: flex;
    align-items: center;
  }
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
`;
